module.exports = __webpack_public_path__ + "static/media/img9.00d47dcf.jpg";